<div cdkDrag cdkDragRootElement=".ant-modal-content">
  <div *nzModalTitle class="inline" cdkDragHandle>
    <span *ngIf="isEditMode">Edit event</span>
    <span *ngIf="!isEditMode">Create event</span>
    <div class="actions">
      <nz-icon
        nzType="shrink"
        nzTheme="outline"
        class="button"
        (click)="modalRef.toggle()"
        *ngIf="!modalRef.minimized"
      />
      <nz-icon
        nzType="arrows-alt"
        nzTheme="outline"
        class="button"
        (click)="modalRef.toggle()"
        *ngIf="modalRef.minimized"
      />
      <nz-icon
        nzType="close-circle"
        (click)="close()"
        class="button cancel"
        nzTheme="outline"
      />
    </div>
  </div>

  <div>
    <nz-spin [nzSpinning]="processing()" nzSize="large">
      <nz-alert
        nzType="warning"
        [nzMessage]="
          'You are about to transform this event type from custom to project'
        "
        nzShowIcon
        *ngIf="isTransformed"
        class="mb-2"
      >
      </nz-alert>

      <nz-alert
        class="mb-2"
        nzType="info"
        nzMessage="Recurring event"
        *ngIf="
          isEditMode &&
          extraOptionExists(ExtraOptionEnum.IsRecurring) &&
          form.get('eventType').value == 'custom'
        "
        [nzDescription]="EditRecurringSeries"
        nzShowIcon
      >
        <ng-template #EditRecurringSeries>
          <div>
            This is a recurring event, checking the below button will edit the
            entire series, otherwise only this event will be edited.
          </div>
          <div
            style="
              display: inline-flex;
              align-items: center;
              gap: 6px;
              margin-top: 6px;
            "
          >
            <nz-switch nzSize="small" [(ngModel)]="editSeries"></nz-switch>
            <b style="line-height: 12px; margin-top: 2px">
              Edit Series (All in this group)
            </b>
          </div>
        </ng-template>
      </nz-alert>

      <nz-alert
        *ngIf="nzData.params.IsReminder"
        class="mb-2"
        nzType="info"
        nzMessage="Reminder event"
        nzDescription="This is a reminder related to another event"
        nzShowIcon
      >
      </nz-alert>

      <form nz-form autocomplete="off" [formGroup]="form">
        <nz-form-item [hidden]="nzData.hideEventTypeSelection">
          <nz-form-control>
            <nz-radio-group
              formControlName="eventType"
              nzButtonStyle="solid"
              style="width: 100%"
            >
              <label
                nz-radio-button
                nzValue="project"
                style="width: 50%; text-align: center"
                [nzDisabled]="!allowType('project')"
                >Project Event</label
              >
              <label
                nz-radio-button
                nzValue="custom"
                style="width: 50%; text-align: center"
                [nzDisabled]="!allowType('custom')"
                >Custom Event</label
              >
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>

        <app-fieldset legend="Summary">
          <nz-form-item>
            <nz-form-label [nzRequired]="form.get('subject') | hasRequired"
              >Description</nz-form-label
            >
            <nz-form-control>
              <textarea
                rows="3"
                nz-input
                id="Subject"
                nzPlaceHolder="Description"
                formControlName="subject"
              ></textarea>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzRequired]="form.get('date') | hasRequired"
              >Timerange</nz-form-label
            >
            <nz-form-control>
              <app-date-picker
                [mode]="'range'"
                [inline]="true"
                [disablePastDates]="false"
                [allowTime]="true"
                [allowClear]="false"
                [allowToday]="false"
                [size]="'default'"
                [preselected]="form.get('date').value"
                (onChange)="onDateChange($event)"
              />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item *ngIf="visibleAddressInput">
            <nz-form-label [nzRequired]="true">Address</nz-form-label>
            <nz-form-control>
              <app-address-form
                #AddressFormEvent
                [addressId]="nzData.params.address"
                [multiInputs]="false"
                class="w-full"
              />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item *ngIf="visibleProjectInput">
            <nz-form-label [nzRequired]="form.get('project') | hasRequired"
              >Project</nz-form-label
            >
            <nz-form-control>
              <div class="inline-flex gap-1 w-full">
                <nz-select
                  nzPlaceHolder="Project"
                  formControlName="project"
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  [nzLoading]="loadingProjects()"
                  [nzDisabled]="
                    loadingProjects() || nzData.disableProjectSelection
                  "
                  (nzOnSearch)="searchProjects = $event"
                  [ngStyle]="{
                    width: form.get('project').value
                      ? 'calc(100% - 76px)'
                      : '100%',
                  }"
                  [nzOptionOverflowSize]="3"
                  [nzOptionHeightPx]="61"
                >
                  <nz-option
                    *ngFor="
                      let option of projects
                        | suggestedSearch: ['label'] : searchProjects
                    "
                    [nzLabel]="option.label"
                    [nzValue]="option.value.id"
                    nzCustomContent
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        ProjectDetails;
                        context: { option: option }
                      "
                    ></ng-container>
                  </nz-option>
                </nz-select>

                <ng-container
                  *ngTemplateOutlet="
                    JobActions;
                    context: { $implicit: form.get('project').value }
                  "
                ></ng-container>
              </div>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzRequired]="form.get('technicians') | hasRequired"
              >Technicians</nz-form-label
            >
            <nz-form-control>
              <nz-select
                nzMode="multiple"
                nzPlaceHolder="Technicians"
                formControlName="technicians"
                [nzServerSearch]="true"
                [(nzOpen)]="showTechniciansDropdown"
                (nzOnSearch)="searchTechnician = $event"
                [nzDropdownStyle]="{ width: '100%' }"
                [nzOptionOverflowSize]="6"
                [nzOptionHeightPx]="35"
              >
                <nz-option
                  *ngFor="
                    let option of state.technicians
                      | suggestedSearch: ['fullName'] : searchTechnician
                  "
                  [nzLabel]="option.firstName"
                  [nzValue]="option.id"
                  nzCustomContent
                >
                  <div
                    style="
                      display: inline-flex;
                      width: 100%;
                      align-items: center;
                    "
                  >
                    <app-avatar
                      [user_id]="option.id"
                      size="small"
                      style="margin-right: 6px"
                    ></app-avatar>
                    {{ option.id | username }}
                  </div>
                </nz-option>
              </nz-select>
            </nz-form-control>

            @if (cartTypeObject) {
              <nz-alert
                nzCloseable
                class="mt-2"
                nzType="info"
                [nzMessage]="cartTypeMessage"
                nzShowIcon
              ></nz-alert>
            }
          </nz-form-item>
        </app-fieldset>

        <app-fieldset legend="Extra options" [hide]="false" class="block mt-3">
          <div>
            <nz-button-group nzSize="small" style="width: 100%">
              <button
                nz-button
                [nzType]="extraOptionClass(ExtraOptionEnum.IsAllDay)"
                (click)="toggleExtra(ExtraOptionEnum.IsAllDay)"
                style="width: 20%"
                [disabled]="!allowExtraOption(ExtraOptionEnum.IsAllDay)"
              >
                All day
              </button>
              <button
                nz-button
                [nzType]="extraOptionClass(ExtraOptionEnum.IsHoliday)"
                (click)="toggleExtra(ExtraOptionEnum.IsHoliday)"
                style="width: 20%"
                [disabled]="!allowExtraOption(ExtraOptionEnum.IsHoliday)"
              >
                Holiday
              </button>
              <button
                nz-button
                [nzType]="extraOptionClass(ExtraOptionEnum.IsRecurring)"
                (click)="toggleExtra(ExtraOptionEnum.IsRecurring)"
                style="width: 20%"
                [disabled]="!allowExtraOption(ExtraOptionEnum.IsRecurring)"
              >
                Recurring
              </button>
              <button
                nz-button
                [nzType]="extraOptionClass(ExtraOptionEnum.IsReminder)"
                (click)="toggleExtra(ExtraOptionEnum.IsReminder)"
                style="width: 20%"
                [disabled]="!allowExtraOption(ExtraOptionEnum.IsReminder)"
              >
                Reminder
              </button>
              <button
                nz-button
                [nzType]="extraOptionClass(ExtraOptionEnum.IsFixedArrival)"
                (click)="toggleExtra(ExtraOptionEnum.IsFixedArrival)"
                style="width: 21%"
                [disabled]="!allowExtraOption(ExtraOptionEnum.IsFixedArrival)"
              >
                Fixed arrival
              </button>
              <button
                nz-button
                [nzType]="extraOptionClass(ExtraOptionEnum.IsAutoDelete)"
                (click)="toggleExtra(ExtraOptionEnum.IsAutoDelete)"
                style="width: 21%"
                [disabled]="!allowExtraOption(ExtraOptionEnum.IsAutoDelete)"
              >
                Auto delete
              </button>
            </nz-button-group>
          </div>
          <!-- Reminder section -->
          <div
            *ngIf="
              extraOptionExists(ExtraOptionEnum.IsReminder) &&
              !nzData.params.IsReminder
            "
          >
            <app-fieldset legend="Reminder Settings" class="block mt-3">
              <nz-form-item class="!m-0">
                <nz-form-label
                  [nzRequired]="form.get('reminderDescription') | hasRequired"
                  >Description</nz-form-label
                >
                <nz-form-control>
                  <nz-textarea-count>
                    <textarea
                      rows="3"
                      nz-input
                      nzPlaceHolder="Description"
                      formControlName="reminderDescription"
                    ></textarea>
                  </nz-textarea-count>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item
                style="
                  display: inline-flex;
                  align-items: end;
                  flex-wrap: nowrap;
                  width: 100%;
                "
              >
                <div style="width: 100%">
                  <nz-form-label
                    [nzRequired]="form.get('reminderDate') | hasRequired"
                    >Timerange</nz-form-label
                  >
                  <nz-form-control>
                    <app-date-picker
                      [mode]="'single'"
                      [inline]="true"
                      [disablePastDates]="false"
                      [disableFutureDates]="true"
                      [allowTime]="true"
                      fixedDuration="02:00"
                      [allowClear]="false"
                      [allowToday]="false"
                      [size]="'default'"
                      [preselected]="form.get('reminderDate').value"
                      (onChange)="form.patchValue({ reminderDate: $event })"
                    />
                  </nz-form-control>
                </div>
                <div>
                  <button
                    nz-button
                    nzType="primary"
                    nz-popover
                    [nzPopoverContent]="CalendarPopover"
                    nzPopoverTrigger="click"
                    nzPopoverPlacement="topLeft"
                    [(nzPopoverVisible)]="isCalendarVisible"
                    (nzPopoverVisibleChange)="reminderPopoverVisibleChange()"
                  >
                    <nz-icon nzType="calendar" nzTheme="outline" />
                  </button>

                  <ng-template #CalendarPopover>
                    @if (
                      form.get('eventType').value !== 'custom' &&
                      form.get('project').value &&
                      selectedProject
                    ) {
                      <ng-container
                        *ngTemplateOutlet="
                          ProjectDetails;
                          context: { option: selectedProject }
                        "
                      ></ng-container>
                    }

                    @if (
                      form.get('date')?.value[0] && form.get('date')?.value[1]
                    ) {
                      <div class="text-xs text-black my-2">
                        Event booked from
                        {{
                          form.get('date')?.value[0] | moment: dateTimeFormat
                        }}
                        to
                        {{
                          form.get('date')?.value[1] | moment: dateTimeFormat
                        }}
                      </div>
                    }
                    <ng-container #CalendarComponent></ng-container>
                  </ng-template>
                </div>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label
                  [nzRequired]="form.get('reminderTechnicians') | hasRequired"
                  >Technicians</nz-form-label
                >
                <nz-form-control>
                  <nz-select
                    nzMode="multiple"
                    nzPlaceHolder="Technicians"
                    formControlName="reminderTechnicians"
                    [nzServerSearch]="true"
                    [nzDropdownStyle]="{ width: '100%' }"
                    [nzServerSearch]="true"
                    [(nzOpen)]="showReminderTechniciansDropdown"
                    (nzOnSearch)="searchReminderTechnician = $event"
                  >
                    <nz-option
                      *ngFor="
                        let option of state.technicians
                          | suggestedSearch
                            : ['fullName']
                            : searchReminderTechnician
                      "
                      [nzLabel]="option.firstName"
                      [nzValue]="option.id"
                      nzCustomContent
                    >
                      <div
                        style="
                          display: inline-flex;
                          width: 100%;
                          align-items: center;
                        "
                      >
                        <app-avatar
                          [user_id]="option.id"
                          size="small"
                          style="margin-right: 6px"
                        ></app-avatar>
                        {{ option.id | username }}
                      </div>
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label
                  [nzRequired]="form.get('reminderAddress') | hasRequired"
                >
                  Address
                </nz-form-label>
                <nz-form-control>
                  <app-address-form
                    #AddressFormReminder
                    [addressId]="nzData.params.reminderEvents?.address"
                    [multiInputs]="false"
                    [required]="false"
                  />
                </nz-form-control>
              </nz-form-item>
            </app-fieldset>
          </div>
          <!-- Recurring section -->
          <div
            *ngIf="
              extraOptionExists(ExtraOptionEnum.IsRecurring) &&
              form.get('eventType').value == 'custom'
            "
          >
            <app-fieldset legend="Recurring Settings" class="block mt-3">
              <app-calendar-recurrence-editor
                #ReccurenceEditor
              ></app-calendar-recurrence-editor>
            </app-fieldset>
          </div>
          <!-- Auto Delete -->
          <div *ngIf="extraOptionExists(ExtraOptionEnum.IsAutoDelete)">
            <app-fieldset legend="Auto Delete" class="block mt-3">
              <nz-form-item>
                <nz-form-label
                  [nzRequired]="extraOptionExists(ExtraOptionEnum.IsAutoDelete)"
                >
                  Reserve for

                  <nz-switch
                    [(ngModel)]="allowManualPeriodInput"
                    (ngModelChange)="
                      formValidatorForAutoDelete();
                      form.patchValue({ daysToDelete: 0 })
                    "
                    [ngModelOptions]="{ standalone: true }"
                    nzCheckedChildren="Manual input"
                    nzUnCheckedChildren="Manual input"
                    style="margin: 0px 0px 2px 6px"
                  ></nz-switch>
                </nz-form-label>
                <nz-form-control>
                  <nz-select
                    formControlName="daysToDelete"
                    *ngIf="!allowManualPeriodInput"
                  >
                    <nz-option
                      *ngFor="let option of daysToDeleteOptions"
                      [nzValue]="option.value"
                      [nzLabel]="option.label"
                    ></nz-option>
                  </nz-select>

                  <nz-input-number
                    *ngIf="allowManualPeriodInput"
                    formControlName="daysToDelete"
                    nzPlaceHolder="Days"
                    [nzMin]="0.5"
                    [nzStep]="0.5"
                    style="width: 100%; margin-top: 6px"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </app-fieldset>
          </div>
        </app-fieldset>

        <app-fieldset legend="Media" [hide]="false" class="block mt-3">
          <nz-spin [nzSpinning]="loadingFiles()" nzSize="large">
            <app-upload-files
              #UploadFilesComponent
              [files]="filelist"
              (countFiles)="countedFiles = $event"
            ></app-upload-files>
          </nz-spin>
        </app-fieldset>
      </form>
    </nz-spin>
  </div>

  <!-- Footer -->
  <div *nzModalFooter cdkDragHandle>
    <div
      style="display: inline-flex; width: 100%; justify-content: space-between"
    >
      <!-- Options -->
      <div class="inline-flex gap-1 items-center" *ngIf="isEditMode">
        <app-avatar
          size="small"
          [user_id]="nzData.params.user_created"
          [tooltip]="false"
          nz-tooltip
          [nzTooltipTitle]="
            'By ' +
            (nzData.params.user_created | username) +
            ' at ' +
            (nzData.params.date_created | moment: dateTimeFormat)
          "
        ></app-avatar>

        <button
          nz-button
          nzType="default"
          nzDanger
          nzSize="small"
          (click)="deleteEvent()"
          [disabled]="processing()"
          nz-tooltip
          nzTooltipTitle="Delete Event"
        >
          <nz-icon nzType="delete" nzTheme="outline" />
        </button>

        <ng-container *ngIf="!isTransformed">
          <button
            nz-button
            nzType="default"
            (click)="openMap()"
            nz-tooltip
            nzSize="small"
            class="!m-0"
            [nzTooltipTitle]="mapAddress() || 'Open Map'"
            *ngIf="!getExtraOptions.IsHoliday"
          >
            <nz-icon nzType="environment" nzTheme="outline" />
          </button>

          @if (nzData?.params?.projectStatus) {
            <nz-tag
              nz-tooltip
              nzTooltipTitle="Project status"
              style="margin: 0px; height: 24px; line-height: 22px"
            >
              {{ nzData.params.projectStatus }}
            </nz-tag>
          }

          <app-module-tag
            [module]="type"
            [clickable]="false"
            [allowTooltip]="false"
            (click)="openJob()"
            nz-tooltip
            nzTooltipTitle="Open Project"
            *ngIf="form.get('eventType').value !== 'custom'"
          ></app-module-tag>
        </ng-container>
      </div>

      <!-- Actions  -->
      <div style="width: 100%">
        <button nz-button nzType="default" (click)="close()">Cancel</button>
        <button
          nz-button
          nzType="primary"
          (click)="save()"
          [disabled]="!valid"
          [nzLoading]="processing()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #JobActions let-id>
  <div class="inline-flex gap-1" *ngIf="id">
    <button
      nz-button
      nzType="default"
      (click)="openMap(id)"
      nz-tooltip
      [nzTooltipTitle]="mapAddress(id) || 'Open map'"
    >
      <nz-icon nzType="environment" nzTheme="outline" />
    </button>

    <button
      nz-button
      nzType="default"
      (click)="openJob(id)"
      nz-tooltip
      nzTooltipTitle="Open project"
    >
      <nz-icon nzType="folder" nzTheme="outline" />
    </button>

    @if (selectedProject.value?.managed_by_id) {
      <app-avatar
        [size]="32"
        [user_id]="selectedProject.value?.managed_by_id"
        [tooltip]="false"
        nz-tooltip
        [nzTooltipTitle]="
          'Managed by ' + (selectedProject.value?.managed_by_id | username)
        "
      ></app-avatar>
    }
  </div>
</ng-template>

<ng-template #ProjectDetails let-option="option">
  <div class="inline-flex items-start w-full gap-2">
    <app-module-tag [module]="option.type" [clickable]="false"></app-module-tag>

    <div
      class="inline-flex flex-col w-full overflow-hidden whitespace-nowrap leading-4"
    >
      @if (option.value.company_name) {
        <small>
          Company: <b>{{ option.value.company_name }}</b>
        </small>
      }

      <small class="w-full overflow-hidden text-ellipsis whitespace-nowrap">
        @if (option.value.delivery_name == option.value.billing_name) {
          Billing & Delivery: <b>{{ option.value.delivery_name }}</b>
        } @else {
          Delivery: <b>{{ option.value.delivery_name }}</b> - Billing:
          <b
            >{{ option.value.billing_title }} {{ option.value.billing_name }}</b
          >
        }
      </small>

      <small class="overflow-hidden text-ellipsis whitespace-nowrap">
        {{
          utilities.formatAddress(option.value, {
            postcode: 'delivery_postcode',
            address1: 'delivery_address1',
            address2: 'delivery_address2',
            city: 'delivery_city',
          })
        }}
      </small>

      <small>
        <app-due-date-tag [due_date]="option.value.due_date"></app-due-date-tag>
      </small>
    </div>

    <nz-tag>
      {{ option.value.project_status }}
    </nz-tag>
  </div>
</ng-template>
